import { render } from "./WelcomeSection.vue?vue&type=template&id=00127c56&scoped=true"
import script from "./WelcomeSection.vue?vue&type=script&lang=js"
export * from "./WelcomeSection.vue?vue&type=script&lang=js"

import "./WelcomeSection.vue?vue&type=style&index=0&id=00127c56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00127c56"]])

export default __exports__